// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/noise-abatement.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/noise-abatement/noise-abatement.js';

mount([g0]);
